/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Board_Col_RateInputs */

const en_analytics_board_col_rate = /** @type {(inputs: Analytics_Board_Col_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rate`)
};

const de_analytics_board_col_rate = /** @type {(inputs: Analytics_Board_Col_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rate`)
};

const fr_analytics_board_col_rate = /** @type {(inputs: Analytics_Board_Col_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taux`)
};

const es_analytics_board_col_rate = /** @type {(inputs: Analytics_Board_Col_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasa`)
};

const it_analytics_board_col_rate = /** @type {(inputs: Analytics_Board_Col_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasso`)
};

const nl_analytics_board_col_rate = /** @type {(inputs: Analytics_Board_Col_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentage`)
};

const pl_analytics_board_col_rate = /** @type {(inputs: Analytics_Board_Col_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wskaźnik`)
};

const fi_analytics_board_col_rate = /** @type {(inputs: Analytics_Board_Col_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prosentti`)
};

const da_analytics_board_col_rate = /** @type {(inputs: Analytics_Board_Col_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rate`)
};

const sv_analytics_board_col_rate = /** @type {(inputs: Analytics_Board_Col_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andel`)
};

/**
* | output |
* | --- |
* | "Rate" |
*
* @param {Analytics_Board_Col_RateInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_board_col_rate = /** @type {((inputs?: Analytics_Board_Col_RateInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Board_Col_RateInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_board_col_rate(inputs)
	if (locale === "fr") return fr_analytics_board_col_rate(inputs)
	if (locale === "es") return es_analytics_board_col_rate(inputs)
	if (locale === "it") return it_analytics_board_col_rate(inputs)
	if (locale === "nl") return nl_analytics_board_col_rate(inputs)
	if (locale === "pl") return pl_analytics_board_col_rate(inputs)
	if (locale === "fi") return fi_analytics_board_col_rate(inputs)
	if (locale === "da") return da_analytics_board_col_rate(inputs)
	if (locale === "sv") return sv_analytics_board_col_rate(inputs)
	return en_analytics_board_col_rate(inputs)
});